import { useState } from "react";
import { DynamicWidget } from "@dynamic-labs/sdk-react-core";
import { useUnifiedWallet } from "~/hooks/useUnifiedWallet";
import { useWalletBalances } from "~/hooks/useWalletBalances";
import { truncateAddress, formatCompactUsd } from "~/lib/format";
import { WalletDrawer } from "./WalletDrawer";

export function ConnectButton() {
  const { address, isConnected } = useUnifiedWallet();
  const { totalValueUsd, isLoading } = useWalletBalances();
  const [drawerOpen, setDrawerOpen] = useState(false);

  if (isConnected && address) {
    return (
      <>
        <button
          onClick={() => setDrawerOpen(true)}
          className="flex items-center gap-2 rounded-[var(--radius-md)] border border-[var(--color-border-modal)] bg-[var(--color-bg-modal-input)] px-3 py-2 text-sm font-medium text-[var(--color-text-primary)] transition-colors hover:bg-[rgba(246,246,246,0.1)]"
        >
          <span>{truncateAddress(address)}</span>
          {!isLoading && totalValueUsd > 0 && (
            <span className="text-[var(--color-text-secondary)]">
              {formatCompactUsd(totalValueUsd)}
            </span>
          )}
        </button>
        <WalletDrawer open={drawerOpen} onClose={() => setDrawerOpen(false)} />
      </>
    );
  }

  return <DynamicWidget />;
}
